// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__HQvQY","notes":"Notes_notes__2_Nxx","note":"Notes_note__2Q-LC","markdown":"Notes_markdown__2fhhr"};